import React from "react";
import moment from "moment";

const DeletedSMBetsTable = ({ plBetList }) => {
  return (
    <div>
      <table className="table table-bordered dataTable">
        <thead>
          <tr className="bg-gray-200">
            <th className="col-balance">UserName</th>
            <th className="col-date">MarketId</th>
            <th className="col-credit">betNo</th>
            <th className="col-sno">Amount</th>
            <th className="col-sno">BetStatus</th>

            <th className="col-date">IP</th>
            <th className="col-date">Date</th>
            <th className="col-date">Delete On</th>
          </tr>
        </thead>
        <tbody className="">
          {plBetList &&
            Array.isArray(plBetList) &&
            plBetList?.map((data, index) => (
              <tr>
                {/* <td onClick={() => handlePlBetList(data)}><span>{data?.Sport}{" > "}{data?.Match}  ({data?.MType})</span> </td> */}
                <td>{data?.UserName}</td>
                <td>{data?.MarketId}</td>
                <td>{data?.betNo}</td>
                <td>{data?.Amount}</td>
                <td>{data?.BetStatus}</td>

                <td>{data?.IP_Address}</td>
                <td>
                  {moment(data?.createdOn).format("DD-MM-YYYY h:mm:ss A")}
                </td>
                <td>
                  {moment(data?.updatedOn).format("DD-MM-YYYY h:mm:ss A")}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default DeletedSMBetsTable;
